module.exports = __webpack_public_path__ + "static/media/AP_ES_Z2.fe77cdd3.png";